// authBootstrap.js
import { createMap } from './mapInstance.js';
import {
  getAccessTokenFromUrl,
  persistAccessToken,
  decodeJwtClaims,
  setAccessToken,
  isTokenExpired 
} from "./securityUtil.js";

function removeAuthTokenFromUrl() {
  const url = new URL(window.location.href);
  if (!url.searchParams.has("auth")) return;

  url.searchParams.delete("auth");
  const cleanPath = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState({}, document.title, cleanPath || "/");
}

export function startApp() {
  const token = getAccessTokenFromUrl();

  if (!token) {
    return { authorized: false, reason: "missing" };
  }

  const claims = decodeJwtClaims(token);
  if (!claims) {
    return { authorized: false, reason: "invalid" };
  }

  if (isTokenExpired(claims)) {
    return { authorized: false, reason: "expired" };
  }

  const userId = claims.userID || claims.userId || claims.sub;
  if (!userId) {
    return { authorized: false, reason: "invalid" };
  }

  setAccessToken(token);
  persistAccessToken(token);
  removeAuthTokenFromUrl();

  const jwtContext = {
    projectId: claims.projectID,
    userId,
    country: claims.country,
    language: claims.language
  };

  return {
    authorized: true,
    token,
    claims,
    jwtContext
  };
}

export function createAuthorizedMap(jwtContext) {
  return createMap(jwtContext);
}

